import type { SidebarSectionDividerComponent } from "@productlane/api/src/browser"
import { cn } from "@productlane/lib/src/cn"

interface Props {
	component: SidebarSectionDividerComponent
}

const SpaceMapping: Record<SidebarSectionDividerComponent["spacing"], string> =
	{
		xs: "my-1",
		s: "my-1.5",
		m: "my-2",
		l: "my-2.5",
		xl: "my-3",
	}

export function DividerComponent({ component }: Props) {
	return (
		<hr
			className={cn(
				"h-px w-full border-0 bg-gray-200 dark:bg-gray-700/80",
				SpaceMapping[component.spacing],
			)}
		/>
	)
}
